import { all } from "@redux-saga/core/effects";
import { noticSaga } from "./NotifactionSaga";
import { contactSaga } from "./ContactSaga";
import { categorySaga } from "./CategorySaga";
import { userSaga } from "./UserSaga";
import { newsletterSaga } from "./NewsletterSaga";

export default function* RootSaga() {
    yield all([
     noticSaga(),
     contactSaga(),
     categorySaga(),
     userSaga(),
     newsletterSaga()
    ])
}
